import { c as _c } from "react/compiler-runtime";
import styles from "./AppWallet.module.scss";
import { Container, Row, Col } from "react-bootstrap";
import Link from "next/link";
import { AppWallet } from "./AppWalletsContext";
import AppWalletAvatar from "./AppWalletAvatar";
export default function AppWalletCard(props) {
  const $ = _c(20);
  const t0 = `/tools/app-wallets/${props.wallet.address}`;
  let t1;
  if ($[0] !== props.wallet.address) {
    t1 = <AppWalletAvatar address={props.wallet.address} />;
    $[0] = props.wallet.address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.wallet.name) {
    t2 = <span className="font-larger font-bolder">{props.wallet.name}</span>;
    $[2] = props.wallet.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.wallet.imported) {
    t3 = props.wallet.imported ? <span className="font-color-h"> (imported)</span> : <></>;
    $[4] = props.wallet.imported;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <Row><Col className="text-break d-flex align-items-center gap-2">{t1}{t2}{t3}</Col></Row>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.wallet.address) {
    t5 = props.wallet.address.toLowerCase();
    $[10] = props.wallet.address;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <Row className="pt-3"><Col className="font-smaller font-lighter text-break">{t5}</Col></Row>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <Container className={styles.appWalletCard}>{t4}{t6}</Container>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t0 || $[18] !== t7) {
    t8 = <Link href={t0} className="decoration-none">{t7}</Link>;
    $[17] = t0;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}